export enum EnumMarketType {
  'Diario' = 1,
  'Mensual' = 2,
  'Trimestral' = 3,
  'Horario' = 4,
  'Laborables' = 5,
  'CuartoHorario' = 6
}
